import { render, staticRenderFns } from "./packing-plan-base-form.vue?vue&type=template&id=48582408&scoped=true"
import script from "./packing-plan-base-form.vue?vue&type=script&lang=ts"
export * from "./packing-plan-base-form.vue?vue&type=script&lang=ts"
import style0 from "./packing-plan-base-form.vue?vue&type=style&index=0&id=48582408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48582408",
  null
  
)

export default component.exports